import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonIndicatorComponent } from './button-indicator.component';

@Component({
  selector: 'app-button-indicator-upload',
  imports: [ButtonIndicatorComponent],
  template: `
    <app-button-indicator
      areaLabelT="admin.batch-creation.upload-file"
      [toolTipT]="toolTipT || 'admin.batch-creation.upload-file'"
      svgIcon="upload"
      [isPending]="isPending"
      (clicked)="this.clicked.emit()"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIndicatorUploadComponent {
  @Input() toolTipT?: string;
  @Input({ required: true }) isPending: boolean;
  @Output() clicked = new EventEmitter<Event>();
}
